import Layout from "@/layout";
export default {
  meta: {
    title: "统计",
    icon: "b-tj",
  },
  path: "/serve",
  component: Layout,
  children: [
    {
      path: "/serve/bxindex",
      name: "servebxindex",
      component: () => import("@/views/serve/bx/index"),
      meta: {
        title: "服务报告",
        auth: [],
        img: "azx",
      },
    },
    {
      path: "/serve/report",
      name: "servereport",
      component: () => import("@/views/report/index"),
      meta: {
        title: "服务报告",
        auth: [],
        img: "azx",
      },
      props: (route) => {
        return route.query;
      },
    },
    {
      path: "/QuarterReport/index",
      name: "QuarterReport",
      component: () => import("@/views/QuarterReport/index"),
      //   component: () => import("@/views/report/index"),

      meta: {
        title: "季度报告",
        auth: [],
        img: "azx",
      },
      props: (route) => {
        return route.query;
      },
    },
    {
      path: "/serve/tixindex",
      name: "servetisindex",
      component: () => import("@/views/serve/tis/index"),
      meta: {
        title: "服务报告",
        auth: [],
        img: "azx",
      },
    },
  ],
};
